import React from 'react';
import { TypographySmall } from '@/Components/shadcn';

interface HeaderProps {
    header: string;
}

function Header({ header }: HeaderProps): React.JSX.Element {
    return <TypographySmall className="uppercase">{header}</TypographySmall>;
}

export default Header;
